export const WALLET_URL = 'https://wallet.qubic.app';
export const PASS_URL = 'https://pass.qubic.app';
